import {
  ADMIN_FRONTEND_VERSION,
  PORTAL_FRONTEND_VERSION,
} from '@repo/constants';
import { isSavedVersionOutdated, useAppType, useVersionQuery } from '@repo/lib';
import { AppType } from '@repo/types';
import { UpdateDialog } from '@ui/components';
import { FC, memo, ReactNode, useEffect, useState } from 'react';

interface VersionProviderProps {
  children: ReactNode;
}

export const VersionProvider: FC<VersionProviderProps> = memo(
  (props: VersionProviderProps) => {
    const { children } = props;

    const appType = useAppType();
    const backendVersion = useVersionQuery(appType);

    const [isOpen, setIsOpen] = useState(false);

    const frontendVersion =
      appType === AppType.PORTAL
        ? PORTAL_FRONTEND_VERSION
        : ADMIN_FRONTEND_VERSION;

    useEffect(() => {
      if (
        backendVersion &&
        isSavedVersionOutdated(frontendVersion, backendVersion)
      ) {
        setIsOpen(true);
      }
    }, [backendVersion, frontendVersion]);

    return (
      <>
        <UpdateDialog
          open={isOpen}
          onOpenChange={setIsOpen}
        />
        {children}
      </>
    );
  },
);

VersionProvider.displayName = 'VersionProvider';
